import "./style.css";

function CustomCard({ children, ...rest }) {
    return (
        <div id="custom-card" {...rest}>
            {children}
        </div>
    );
}

export default CustomCard;